var map = {
	"./bootstrap.svg": 243,
	"./chakraui.5ff1881b.png": 286,
	"./css.svg": 588,
	"./cypress.png": 132,
	"./express.svg": 634,
	"./html.svg": 537,
	"./java.svg": 973,
	"./javascript.svg": 459,
	"./mongodb.svg": 468,
	"./mongoose.png": 86,
	"./nodejs.svg": 992,
	"./postman.png": 52,
	"./programming-skills.svg": 61,
	"./react.svg": 25,
	"./redux.svg": 801,
	"./tailwindcss.svg": 484,
	"./typescript.svg": 302
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 956;